import React, { useState, useContext, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { FileContext } from "./Dashboard";
import { useModal } from "../contexts/ModalContext";

import { db } from "../firebase";

import { collection, deleteDoc, query, getDocs } from "firebase/firestore";

export default function UpdateFiles() {
  const { currentUser } = useAuth();
  const { modalDispatch } = useModal();

  const { setIsSelected, setSelectedFile, loading, setLoading, change, setChange } =
    useContext(FileContext);

  const [dropdownActive, setDropdownActive] = useState(false);

  useEffect(() => {
    return () => {};
  });

  const handleClick = () => {
    setDropdownActive((prevDropdownActive) => !prevDropdownActive);
  };

  const qEntire = query(collection(db, `users/${currentUser.uid}/bias_reports`));

  // const qRecent = query(
  //   collection(db, `users/${currentUser.uid}/bias_reports/`),
  //   orderBy("timestamp", "desc"),
  //   limit(1)
  // );

  async function handleDeleteEntire() {
    setLoading(true);
    const promises = [];

    try {
      let querySnapshot = await getDocs(qEntire);
      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          promises.push(deleteDoc(doc.ref));
        });

        Promise.all(promises)
          .then(() => {
            setLoading(false);
            modalDispatch({
              type: "SHOW_SUCCESS",
              payload: "Deleted entire report history",
            });
            setChange(!change);
          })
          .catch(() => {
            setLoading(false);
            modalDispatch({
              type: "SHOW_ERROR",
              payload: "Failed to delete report history, try again",
            });
          });
      } else {
        setLoading(false);
        return modalDispatch({
          type: "SHOW_ERROR",
          payload: "Nothing to delete",
        });
      }
    } catch (error) {
      setLoading(false);
      return modalDispatch({
        type: "SHOW_ERROR",
        payload: "Could not get report data, error: " + error,
      });
    }
  }

  // async function handleDeleteRecent() {
  //   setLoading(true);
  //   const promises = [];

  //   try {
  //     let querySnapshot = await getDocs(qRecent);
  //     if (!querySnapshot.empty) {
  //       querySnapshot.forEach((doc) => {
  //         promises.push(deleteDoc(doc.ref));
  //       });

  //       Promise.all(promises)
  //         .then(() => {
  //           modalDispatch({
  //             type: "SHOW_SUCCESS",
  //             payload: "Deleted most recent report",
  //           });
  //           setChange(!change);
  //           setLoading(false);
  //         })
  //         .catch(() => {
  //           modalDispatch({
  //             type: "SHOW_ERROR",
  //             payload: "Failed to delete most recent report, try again",
  //           });
  //           setLoading(false);
  //         });
  //     } else {
  //       modalDispatch({
  //         type: "SHOW_ERROR",
  //         payload: "Nothing to delete",
  //       });
  //       return setLoading(false);
  //     }
  //   } catch (error) {
  //     modalDispatch({
  //       type: "SHOW_ERROR",
  //       payload: "Could not get report data, error: " + error,
  //     });
  //     return setLoading(false);
  //   }
  // }

  return (
    <>
      <section className="update-section">
        <div className="update-section-container">
          <div className="update-controls-container">
            <div className="update-controls">
              <div className="update-buttons">
                <label className="btn" htmlFor="uploadCSV">
                  Update trades
                </label>

                <input
                  accept=".csv"
                  type="file"
                  id="uploadCSV"
                  name="trading-file-upload"
                  onClick={(e) => {
                    e.target.value = "";
                  }}
                  onChange={(e) => {
                    if (e.target.files) {
                      setSelectedFile(e.target.files[0]);
                      setIsSelected(true);
                    } else {
                      setIsSelected(false);
                    }
                  }}
                />
                <div
                  className="btn dropdown-btn left-400"
                  onClick={handleClick}
                  onMouseEnter={() => {
                    if (!("ontouchstart" in document.documentElement)) {
                      setDropdownActive(true);
                    }
                  }}
                  onMouseLeave={() => setDropdownActive(false)}
                >
                  {dropdownActive
                    ? "Delete  " + String.fromCharCode(9650)
                    : "Delete  " + String.fromCharCode(9660)}
                  {dropdownActive && (
                    <>
                      <div className="dropped-btn-container">
                        {/* <button
                          className="btn dropped-btn"
                          onClick={handleDeleteRecent}
                          disabled={loading}
                        >
                          Most recent report
                        </button> */}
                        <button
                          className="btn dropped-btn"
                          onClick={handleDeleteEntire}
                          disabled={loading}
                        >
                          Entire report history
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="btn-subtext">.csv file format required &nbsp;</div>
              <div className="btn-subtext"> (max. file size 5MB) </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
